import Layout from '@/layout/index.vue'

export const DocumentDetailsRoute = {
  path: '/document-details',
  component: Layout,
  children: [
    {
      path: ':documentId',
      component: (): Promise<any> =>
        import(/* webpackChunkName: "document-details" */ '@/features/document-details/views/index.vue'),
      name: 'DocumentDetailsIndexRoute',
      meta: {
        title: 'DocumentDetailsIndexRouteTitle',
        requiresAuth: true
      }
    }
  ]
}
